var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"short"},[_vm._v(" "+_vm._s(_vm.$t('matches.shortPickban', { team: _vm.name }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }